import React from "react";
import "./Contact.css";

import { motion } from "framer-motion";
import transition from "../../transition";

import RevealHeading from "../shared/RevealHeading";
import Seo from "../../seo/Seo";
import { breadcrumbJsonLd } from "../../seo/site";
import { useLang, useTranslations } from "../../i18n";

const ease = [0.83, 0, 0.17, 1];

const Contact = () => {
  const lang = useLang();
  const t = useTranslations();
  const c = t.contact;

  return (
    <motion.div className="Home page">
      <Seo
        lang={lang}
        path="/contact"
        title={t.seo.contactTitle}
        description={t.seo.contactDesc}
        jsonLd={breadcrumbJsonLd([
          { name: t.nav.index, path: `/${lang}` },
          { name: t.nav.contact, path: `/${lang}/contact` },
        ])}
      />
      <div className="bg"></div>
      <h1 className="visually-hidden">
        {c.title1} {c.title2}
      </h1>

      <section className="page-hero">
        <div className="headers">
          <div className="header">
            <RevealHeading delay={-0.25}>{c.title1}</RevealHeading>
            <RevealHeading delay={-0.1}>&nbsp;{c.title2}</RevealHeading>
          </div>
        </div>
        <motion.div
          className="page-hero-meta"
          initial={{ opacity: 0, y: 40, transition: { duration: 1, ease } }}
          animate={{
            opacity: 1,
            y: 0,
            transition: { duration: 1.5, ease, delay: 0.6 },
          }}
        >
          <p>{c.meta1}</p>
          <p>{c.meta2}</p>
        </motion.div>
      </section>

      <motion.section
        className="contact"
        initial={{ opacity: 0, y: 60, transition: { duration: 1, ease } }}
        animate={{
          opacity: 1,
          y: 0,
          transition: { duration: 1.5, ease, delay: 0.8 },
        }}
      >
        <a className="contact-email" href="mailto:elmajdoubmounir@gmail.com">
          elmajdoubmounir@gmail.com &#8599;
        </a>

        <div className="contact-grid">
          <div className="contact-block">
            <p>{c.phone}</p>
            <div className="contact-list">
              <a href="tel:+212777477316">+212 777 477 316</a>
              <a href="tel:+212522023822">+212 522 023 822</a>
            </div>
          </div>
          <div className="contact-block">
            <p>{c.email}</p>
            <div className="contact-list">
              <a href="mailto:elmajdoubmounir@gmail.com">
                elmajdoubmounir@gmail.com
              </a>
            </div>
          </div>
          <div className="contact-block">
            <p>{c.social}</p>
            <div className="contact-list">
              <a
                href="https://www.linkedin.com/in/elmajdoubmounir/"
                target="_blank"
                rel="noreferrer"
              >
                {t.home.linkedin} &#8599;
              </a>
              <a
                href="https://www.instagram.com/mejdubmunir"
                target="_blank"
                rel="noreferrer"
              >
                {t.home.instagram} &#8599;
              </a>
            </div>
          </div>
          <div className="contact-block">
            <p>{c.location}</p>
            <div className="contact-list">
              <p>{c.casablanca}</p>
              <p>{c.morocco}</p>
            </div>
          </div>
        </div>
      </motion.section>

      <div className="footer">
        <div className="divider"></div>
        <div className="footer-content">
          <div className="footer-col">
            <p>
              {c.copy} <br /> {c.footerName}
            </p>
          </div>
          <div className="footer-col">
            <p>{t.projects.footerTitle}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default transition(Contact);
